import { OpenAI } from "openai";

let client: OpenAI;

export function init() {
    if (!process.env.REACT_APP_OPENAI_API_KEY) {
        throw Error("No API key!");
    }

    client = new OpenAI({
        organization: "org-PLOQrmXXbo0UNOqoMEwG6lKE",
        apiKey: process.env.REACT_APP_OPENAI_API_KEY,
        dangerouslyAllowBrowser: true
    });
}

export async function getStoryText(_prompt: string): Promise<OpenAI.Completions.Completion> {
    return client.completions.create({ 
        model: "gpt-3.5-turbo-instruct",
        prompt: _prompt,
        max_tokens: 4000
    });
}

export async function getStoryImage(_prompt: string): Promise<OpenAI.Images.ImagesResponse> {
    return client.images.generate({
        model: "dall-e-3",
        prompt: _prompt,
        size: "1024x1024",
        quality: "standard",
        n: 1
    });
}

export async function createAudio(text: string): Promise<ArrayBuffer> {
    const resp = await client.audio.speech.create({
        model: "tts-1",
        voice: "shimmer",
        input: text,
    });
    return await resp.arrayBuffer();
}